module.exports = __webpack_public_path__ + "static/smi5-28effaa73472064a8819b4e7aa0a6966.png";